import { connect } from 'react-redux';
import Link from './link';

export const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Link);
